var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60156 3.77776H5.80656M5.80656 3.77776H7.27656M5.80656 3.77776V3.10156M7.27656 3.77776H8.50156M7.27656 3.77776C7.01756 4.70176 6.47716 5.57536 5.85906 6.34326M5.85906 6.34326C5.34806 6.97956 4.78316 7.54236 4.28406 8.00156M5.85906 6.34326C5.54406 5.97366 5.10306 5.37656 4.97706 5.10636M5.85906 6.34326L6.80406 7.32536",
    stroke: "#2B2B67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0154 11.4846C5.0539 12.6886 5.1848 13.4271 5.6356 13.9766C5.75186 14.1182 5.88175 14.2481 6.0234 14.3644C6.799 15 7.9484 15 10.25 15C12.5516 15 13.7017 15 14.4766 14.3644C14.6185 14.2477 14.7477 14.1185 14.8644 13.9766C15.5 13.201 15.5 12.0516 15.5 9.75C15.5 7.4491 15.5 6.2983 14.8644 5.5234C14.7481 5.38175 14.6182 5.25186 14.4766 5.1356C13.9292 4.6869 13.1949 4.5546 12 4.5161M5.0154 11.4846C3.8114 11.4461 3.0729 11.3152 2.5234 10.8644C2.38175 10.7481 2.25187 10.6182 2.1356 10.4766C1.5 9.701 1.5 8.5516 1.5 6.25C1.5 3.9491 1.5 2.7983 2.1356 2.0234C2.25187 1.88175 2.38175 1.75187 2.5234 1.6356C3.299 1 4.4484 1 6.75 1C9.0509 1 10.2017 1 10.9766 1.6356C11.1182 1.75187 11.2481 1.88175 11.3644 2.0234C11.8152 2.5729 11.9461 3.3114 11.9846 4.5154L12 4.5161M5.0154 11.4846L12 4.5161",
    stroke: "#2B2B67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19922 12.8992L9.78232 11.4992M9.78232 11.4992L10.9492 8.69922L12.1161 11.4992M9.78232 11.4992H12.1161M12.1161 11.4992L12.6992 12.8992",
    stroke: "#2B2B67",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateIcon);
export default __webpack_public_path__ + "static/media/translate-icon.7a57a79d7f73b162fbb8753a6e5acbc8.svg";
export { ForwardRef as ReactComponent };